import {
  LocalStorage,
  keysToCamelCaseDeep,
  keysToSnakeCase,
} from '@agro1desenvolvimento/utils-js';
import {
  ParseToJSON,
  ParseToString,
} from '@agro1desenvolvimento/utils-js/dist/store-base';
import { get, isObject, isString } from 'lodash';
import { Propriedade, User } from '../@types';

export type LocalStoreData = {
  user: User;
  currentPropriedade: Propriedade;
  'api::l_s': string;
  apiHostUrl: string;
};

const parsersToString: Partial<Record<keyof LocalStoreData, ParseToString>> = {
  currentPropriedade: (value) =>
    isObject(value) ? JSON.stringify(keysToSnakeCase(value)) : '',
};

const parsersToJson: Partial<Record<keyof LocalStoreData, ParseToJSON>> = {
  currentPropriedade: (value) =>
    isString(value) ? keysToCamelCaseDeep(JSON.parse(value)) : value,
};

const parseToString: ParseToString = (value, key) => {
  const parser: ParseToString = get(
    parsersToString,
    key,
    LocalStorage.defaultParseToString,
  );

  return parser(value, key);
};

const parseToJson: ParseToJSON = (value, key) => {
  const parser: ParseToJSON = get(
    parsersToJson,
    key,
    LocalStorage.defaultParseToJSON,
  );

  return parser(value, key);
};

export default new LocalStorage<LocalStoreData>(parseToString, parseToJson);
